function normalizeEmail(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
}

function parseCanaryEmails(value) {
  return String(value || "")
    .split(",")
    .map(normalizeEmail)
    .filter(Boolean)
}

function isConfiguredCanaryAccount({ email, canaryEmails }) {
  const currentEmail = normalizeEmail(email)
  if (!currentEmail) {
    return false
  }

  return parseCanaryEmails(canaryEmails).includes(currentEmail)
}

const PHOTO_SAVE_GUIDE_TESTER_EMAIL = "ceo@nnbent.kr"
const PHOTO_SAVE_GUIDE_TESTER_EMAILS = [
  PHOTO_SAVE_GUIDE_TESTER_EMAIL,
  "hellolim86@gmail.com",
  "tyui6411@hanmail.net",
].map(normalizeEmail)

function isPhotoSaveGuideTesterAccount(email) {
  return PHOTO_SAVE_GUIDE_TESTER_EMAILS.includes(normalizeEmail(email))
}

function mayUseEnhancedMyPage({
  email,
  runtimeProfile,
  canaryEmails,
  publicRelease,
}) {
  if (runtimeProfile === "staging-parity") {
    return true
  }

  if (publicRelease === true) {
    return true
  }

  const currentEmail = normalizeEmail(email)
  if (!currentEmail) {
    return false
  }

  return parseCanaryEmails(canaryEmails).includes(currentEmail)
}

module.exports = {
  PHOTO_SAVE_GUIDE_TESTER_EMAIL,
  PHOTO_SAVE_GUIDE_TESTER_EMAILS,
  isConfiguredCanaryAccount,
  isPhotoSaveGuideTesterAccount,
  mayUseEnhancedMyPage,
  normalizeEmail,
  parseCanaryEmails,
}
